import { useState } from "react";
import { Box, Button, FormControlLabel, Typography } from "@mui/material";
import MissingServiceModal from "../../MissingServiceModal";
import CustomCheckboxLabel from "../../../../../Components/CustomCheckboxLabel";
import { useTranslation } from "react-i18next";

const ModalFooter = ({
  onNext,
  onPrevious,
  activeStep,
  formik,
  onSave,
  categories,
  isNextDisabled,
  isStep0NextDisabled,
  isSaveDisabled,
  isSubmitting,
  isExistingPricelist,
}) => {
  const { t } = useTranslation("pricelist-modal");
  const [showMissingModal, setShowMissingModal] = useState(false);
  const [offerAllCommunities, setOfferAllCommunities] = useState(true);

  const handleSaveClick = () => {
    !isExistingPricelist &&
      formik.setFieldValue("offer_to_communities", offerAllCommunities);
    onSave();
  };

  const combinedNextDisabled =
    activeStep === 0
      ? isStep0NextDisabled
      : activeStep === 1
      ? isNextDisabled
      : activeStep === 2
      ? isSaveDisabled
      : false;

  return (
    <Box
      sx={{
        background: "#fff",
        boxShadow: "0px -3px 8px 0px rgba(47, 43, 61, 0.08)",
        zIndex: 10,
        borderTop: "1px solid #EAEAEA",
      }}
    >
      {activeStep === 2 && !isExistingPricelist && (
        <Box>
          <FormControlLabel
            fontSize="15px"
            sx={{
              display: { xs: "flex", md: "none" },
              ml: 0,
              "& .MuiFormControlLabel-root": {
                ml: 0,
              },
              "& .muiltr-kitk5s-MuiTypography-root": {
                fontSize: 15,
                important: true,
              },
            }}
            control={
              <CustomCheckboxLabel
                checked={offerAllCommunities}
                onChange={(e) => setOfferAllCommunities(e.target.checked)}
              />
            }
            label={t("offer_all_communities")}
          />
        </Box>
      )}

      {activeStep === 0 && (
        <Typography
          sx={{
            fontSize: "15px",
            color: "#2F2B3D",
            display: { xs: "block", sm: "none" },
            p: "16px",
            py: "9px",
          }}
        >
          {t("cant_find")}{" "}
          <span
            style={{
              color: "#248B70",
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: 500,
              whiteSpace: "nowrap",
            }}
            onClick={() => setShowMissingModal(true)}
          >
            {t("click_here")}
          </span>
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          p: "16px",
          gap: 1,
          borderTop: "1px solid #EAEAEA",
        }}
      >
        <Button
          sx={{
            textTransform: "capitalize",
            backgroundColor: "#808390",
            borderRadius: "8px",
            fontSize: { xs: "13px", md: "15px" },
            fontWeight: "500",
            color: "white",
            boxShadow: "none",
            "&:hover": { backgroundColor: "#808399", boxShadow: "none" },
          }}
          onClick={onPrevious}
          variant="contained"
        >
          {activeStep === 0 ? t("back_without_saving") : t("back")}
        </Button>

        {activeStep === 0 && (
          <Typography
            sx={{
              fontSize: "15px",
              color: "#2F2B3D",
              display: { xs: "none", sm: "block" },
            }}
          >
            {t("cant_find")}{" "}
            <span
              style={{
                color: "#248B70",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: 500,
                whiteSpace: "nowrap",
              }}
              onClick={() => setShowMissingModal(true)}
            >
              {t("click_here")}
            </span>
          </Typography>
        )}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap={4}
        >
          {activeStep === 2 && !isExistingPricelist && (
            <FormControlLabel
              fontSize="15px"
              sx={{ display: { xs: "none", md: "flex" } }}
              control={
                <CustomCheckboxLabel
                  checked={offerAllCommunities}
                  onChange={(e) => setOfferAllCommunities(e.target.checked)}
                />
              }
              label={t("offer_all_communities")}
            />
          )}

          <Button
            onClick={activeStep === 2 ? handleSaveClick : onNext}
            sx={{
              textTransform: "capitalize",
              backgroundColor: "#257C6D",
              borderRadius: "8px",
              fontSize: "15px",
              fontWeight: "500",
              color: "white",
              boxShadow: "none",
              "&:hover": { backgroundColor: "#257C6D9", boxShadow: "none" },
            }}
            variant="contained"
            disabled={combinedNextDisabled || isSubmitting}
          >
            {activeStep === 2 ? t("save_pricelist") : t("next")}
          </Button>
        </Box>
      </Box>
      {showMissingModal && (
        <MissingServiceModal
          showMissingModal={showMissingModal}
          setShowMissingModal={setShowMissingModal}
          categories={categories}
          subcategoryId={formik.values.pricelist.subcategory_id}
          subcategoryName={formik.values.pricelist.subcategory_name}
        />
      )}
    </Box>
  );
};

export default ModalFooter;
